export default "<div class=\"owl-carousel\" [id]=\"carouselId\">\n  <ng-content select=\"[body]\"></ng-content>\n</div>\n<div class=\"owl-controls\"> </div>";